import pageImage from "AdvisoryManagement/Assets/Images/ZZJ.png";

export const ZzjPage = () => {
	return (
		<img
			src={pageImage}
			alt="ZZJ"
			style={{ maxWidth: "100%", height: "auto" }}
		/>
	);
};
